import React from 'react';

import Tooltip from 'components/Tooltip';

import Title from './Title';

/**
 * The question title component. Displays the count, question, and code
 * snippet. In the sample mode, display the tooltip alongwith the title.
 *
 * @param {*} { sample, number, total, text, codeSnippet }
 * @returns
 */
const TitleWithTip = React.memo(({ sample, number, total, text, codeSnippet, codeSnippetLanguage }) => {
  const QuestionTitle = () => (
    <Title
      number={number}
      total={total}
      text={text}
      codeSnippet={codeSnippet}
      codeSnippetLanguage={codeSnippetLanguage}
    />
  );

  if (sample) {
    return (
      <Tooltip visible placement="top" data={() => <>Your Question</>}>
        {() => <QuestionTitle />}
      </Tooltip>
    );
  }

  return <QuestionTitle />;
});

export default TitleWithTip;
